import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import SelectInput from './SelectInput';

import { triggerEvent } from '../../helpers/global.js';

import '../../sass/components/input/OpeningHoursInput.scss';

const DAYS = [
  { id: 'monday', name: 'Mon' },
  { id: 'tuesday', name: 'Tue' },
  { id: 'wednesday', name: 'Wed' },
  { id: 'thursday', name: 'Thu' },
  { id: 'friday', name: 'Fri' },
  { id: 'saturday', name: 'Sat' },
  { id: 'sunday', name: 'Sun' },
];

const TIMES = [
  ...[...Array(25)].map((v, i) => ({
    id: i*30*60,
    name: `${`${Math.floor(i / 2)}`.padStart(2, '0')}:${`${i%2*30}`.padStart(2, '0')} AM`,
  })),
  ...[...Array(24)].map((v, i) => ({
    id: (i+25)*30*60,
    name: `${`${Math.floor((i+1) / 2)}`.padStart(2, '0')}:${`${(i+1)%2*30}`.padStart(2, '0')} PM`,
  }))
];

const mapStoreToProps = (store) => {
  return {
    isMobile: store.setup.isMobile,
  }
};

class OpeningHoursInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleChange = (value) => {
    this.props.onChange(this.props.objectKey, value);
  }

  addGroup = () => {
    const object = this.props.object || [];
    this.handleChange([
      ...object,
      {
        id: `$${Date.now()}`,
        days: [],
        ended_at: null,
        started_at: null,
      },
    ]);
  }

  removeGroup = (group) => {
    const object = this.props.object || [];
    this.handleChange(
      object.filter(i => i.id !== group.id)
    );
  }

  updateGroup = (group, key, value) => {
    const object = this.props.object || [];
    this.handleChange(
      object.map(i => i.id === group.id ? {
        ...i,
        [key]: value,
      } : i)
    );
    if (key === 'started_at' && group.ended_at !== null && value >= group.ended_at) {
      setTimeout(() => {
        this.updateGroup(group, 'ended_at', null);
        triggerEvent('showSnackbar', [{text: 'Start time must be less then end time', type: 'error'}]);
      }, 150);
    }
    if (key === 'ended_at' && group.started_at !== null && value <= group.started_at) {
      setTimeout(() => {
        this.updateGroup(group, 'started_at', null);
        triggerEvent('showSnackbar', [{text: 'Start time must be less then end time', type: 'error'}]);
      }, 150);
    }
  }

  switchDay = (group, day) => {
    const groupDays = group.days.map(i => i.day);
    const selected = groupDays.includes(day.id);
    if (selected) {
      this.updateGroup(group, 'days', group.days.filter(j => j.day !== day.id));
    } else {
      this.updateGroup(group, 'days', [...group.days, { id: `$${Date.now()}`, day: day.id }]);
    }
  }

  renderGroup = (group) => {
    const groupDays = group.days.map(i => i.day);
    return (
      <div key={group.id} className='groupItem'>
        <div className='groupDays'>
          {DAYS.map(day =>
            <div
              key={day.id}
              className={classnames('dayItem', {
                'selected': groupDays.includes(day.id),
              })}
              onClick={() => this.switchDay(group, day)}
            >
              {day.name}
            </div>
          )}
        </div>
        {this.props.isMobile ? null :
          <span>From</span>
        }
        <SelectInput
          properties={{
            type: 'select',
            options: TIMES,
          }}
          object={group.started_at}
          onChange={(k, val) => this.updateGroup(group, 'started_at', val)}
        />
        <span>{this.props.isMobile ? '-' : 'To'}</span>
        <SelectInput
          properties={{
            type: 'select',
            options: TIMES,
          }}
          object={group.ended_at}
          onChange={(k, val) => this.updateGroup(group, 'ended_at', val)}
        />
        <div className='removeButton' onClick={() => this.removeGroup(group)}>
          {this.props.isMobile ? 'Remove' : null}
        </div>
      </div>
    )
  }

  render = () => {
    const object = this.props.object || [];
    return (
      <div className='openingHoursInput'>
        {object.map(this.renderGroup)}
        <div
          className='addButton'
          onClick={this.addGroup}
        >+ Add opening hours</div>
      </div>
    )
  }

}

export default connect(mapStoreToProps)(OpeningHoursInput);
